import { fromJS } from 'immutable'
import { get } from 'lodash'
import { IActionProps } from 'types'

import { SET_OPTIONS_LIST_SUCCESS } from './constants'

const initialState = fromJS({})

const optionsSetReducer = (
  state = initialState,
  { type, payload }: IActionProps,
) => {
  switch (type) {
    case SET_OPTIONS_LIST_SUCCESS: {
      const { id, data } = get(payload, 'meta')
      return state.set(id, data)
    }
    default:
      return state
  }
}

export default optionsSetReducer
